export const getLoadedScripts = () =>
  Array.from(document.getElementsByTagName('script')).map((s) => s.src);
